<div class="container" id="expensse">
  <div>
 
    <ion-row>
      <!-- <ion-col size="12" size-md="6" size-lg="12"> -->
        <!-- <ion-row class="borderbottomForTab"> -->
          <ion-col size="12">
            <div class="phi-flex-wrap-center phi-gap-12 borderbottomForTab pb-10">
           
              <mat-form-field class="w-100 mw-sm-250 mat mat-height40 mat-input-style">
                <mat-select [(value)]="selectedOptioMain" (selectionChange)="onChangeExpenseDate($event.value,'allGraph')">
                  <mat-option *ngFor="let option of dateRangeOptions" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              
              <mat-form-field class="w-100 mw-sm-250 mat mat-height40 mat-input-style" *ngIf="selectedOptioMain === 'custom'">
                <mat-date-range-input [rangePicker]="fromToDateDashboard">
                  <input matStartDate placeholder="Start date" [(ngModel)]="taskDateRange.start" name="startDate" readonly>
                  <input matEndDate placeholder="End date" [(ngModel)]="taskDateRange.end" name="endDate" readonly>
                </mat-date-range-input>
              
                <mat-datepicker-toggle matIconSuffix [for]="fromToDateDashboard"></mat-datepicker-toggle>
                <mat-date-range-picker 
                  #fromToDateDashboard 
                  (closed)="processDateRangeOnlyForCustomRange('allGraph')">
                </mat-date-range-picker>
              </mat-form-field>
               
              
              <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style"  *ngIf="selectedOptioMain === 'fiscal'">
                <mat-select placeholder="Select" [(ngModel)]="selectedYearForReimbursementTop" 
                  (selectionChange)="onChangeFiscalYearTop($event.value,'allGraph')">
                  <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                    {{sharedService.transformYearToFyFormat(item.year)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
 
              <mat-form-field *ngIf="(loggedInUserRole == 'Manager' || loggedInHODManager == 'HODManager') && !OnlyFinance " class="w-100 mw-sm-250 mat mat-height40 mat-input-style">
                <mat-select placeholder="Select Employee" (selectionChange)="onEmployeeChangeByManager($event.value)"
                  [(ngModel)]="employeeID">
                  <mat-option *ngFor="let item of getEmployeeList" [value]="item.employeeId" >
                    {{ item.employeeName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

            </div>
          </ion-col>

       
    </ion-row>
  </div> 


  <!-- ================= Dashboard Count ================================ -->
  
  <ion-row class="pt-10">
    <!-- Expenses Raised -->
    <ion-col size="12" size-md="4" *ngIf="(loggedInUserRole == 'Manager' || loggedInHODManager == 'HODManager') && !OnlyFinance && OnlyManager">
    <!-- <ion-col size="12" size-md="4" > -->
      <div class="card expense-card h-100" 
           [class.disabled-card]="pendingWithManager <= 0"
           (click)="pendingWithManager > 0 && onClickCard('Manager')">
        <div class="phi-flex-center phi-gap-12">
          <mat-icon class="expense-icon">
            <span><img class="cp" src="././assets/icon/activeEmp.svg" alt=""></span>
          </mat-icon>
          <div class="text-center">
            <p class="fs-12 font_semibold expense-title">No. of expense pending from manager</p>
            <p class="mt-5 fs-12 font_bold Cerulean-black cp expense-count">{{ pendingWithManager }}</p>
          </div>
        </div>
      </div>
    </ion-col>
    
    <ion-col size="12" size-md="4">
      <div class="card expense-card h-100" 
           [class.disabled-card]="totalExpenseRaisedCount <= 0"
           (click)="totalExpenseRaisedCount > 0 && onClickCard(1)">
        <div class="phi-flex-center phi-gap-12">
          <mat-icon class="expense-icon">receipt_long</mat-icon>
          <div class="text-center">
            <p class="fs-12 font_semibold expense-title">No of expenses raised</p>
            <p class="mt-5 fs-12 font_bold Cerulean-black cp expense-count">
              {{ totalExpenseRaisedCount }}
            </p>
          </div>
        </div>
      </div>
    </ion-col>
    
    <!-- Expenses Approved -->
    <ion-col size="12" size-md="4">
      <div class="card expense-card h-100" 
           [class.disabled-card]="totalExpenseApprovedByfinance <= 0"
           (click)="totalExpenseApprovedByfinance > 0 && onClickCard(3)">
        <div class="phi-flex-center phi-gap-12">
          <mat-icon class="expense-icon text_green">how_to_reg</mat-icon>
          <div class="text-center">
            <p class="fs-12 font_semibold cp expense-title">
              No. of expense approved by finance
            </p>
            <p class="mt-5 fs-12 font_bold Cerulean-black cp expense-count">
              {{ totalExpenseApprovedByfinance }}
            </p>
          </div>
        </div>
      </div>
    </ion-col>
    
  
    <!-- Expenses Pending -->
    <ion-col size="12" size-md="4">
      <div class="card expense-card h-100" 
           [class.disabled-card]="totalExpensePendingByfinance <= 0"
           (click)="totalExpensePendingByfinance > 0 && onClickCard(4)">
        <div class="phi-flex-center phi-gap-12">
          <mat-icon class="expense-icon text-warning">schedule</mat-icon>
          <div class="text-center">
            <p class="fs-12 font_semibold cp expense-title">
              No. of expense pending by finance
            </p>
            <p class="mt-5 fs-12 font_bold Cerulean-black cp expense-count">
              {{ totalExpensePendingByfinance }}
            </p>
          </div>
        </div>
      </div>
    </ion-col>
    
  </ion-row>
  
   
  <ion-row class="pt-10">
    <ion-col  size="12" size-md="6">
      <div class="graphs">
        <ion-row class="justify-content-center">
          <ion-col size="12" size-md="7">
            <div class="fs-16 fs_14ForMobile font_bold">Expense Applied Count</div>
          </ion-col>
          <ion-col size="12" size-md="5">
            <div class="d-flex graph-icon">
              <span (click)="switchReimbursementTypeGraph('bar')">
                <img *ngIf="isReimbursementTypeIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
                <img *ngIf="isReimbursementTypeIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
              </span>
              <span (click)="switchReimbursementTypeTable()">
                <img *ngIf="!isReimbursementTypeTable" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                <img *ngIf="isReimbursementTypeTable" src="././assets/icon/TableIconActive.svg" alt="">
              </span>
              <span (click)="switchReimbursementTypeGraph('line')">
                <img *ngIf="isReimbursementTypeIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt=""
                  class="cp">
                <img *ngIf="isReimbursementTypeIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
              </span>
              <span>
                <img (click)="downloadChartAsPDF('Expense Applied Count',selectedOption)" src="././assets/icon/downloadIcon.svg" alt=""
                  class="cp">
              </span>
            </div>
          </ion-col>
        </ion-row>

        <div class="phi-flex-wrap-center phi-gap-12 mt-10 mb-10">
          <!-- <ion-row> -->
            <!-- <div class="d-flex "> -->
              <mat-form-field class="w-100 mw-sm-250 mat mat-height40 mat-input-style mr-15" >
                <mat-select [(value)]="selectedOption" (selectionChange)="onChangeExpenseDate($event.value,'FirstGraph')">
                  <mat-option *ngFor="let option of dateRangeOptions" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="w-100 mw-sm-250 mat mat-height40 mat-input-style" *ngIf="selectedOption === 'custom'">
                <mat-date-range-input [rangePicker]="fromToDateDashboard">
                  <input matStartDate placeholder="Start date" [(ngModel)]="taskDateRangeFirstGraph.start" name="startDate" readonly>
                  <input matEndDate placeholder="End date" [(ngModel)]="taskDateRangeFirstGraph.end" name="endDate" readonly>
                </mat-date-range-input>
              
                <mat-datepicker-toggle matIconSuffix [for]="fromToDateDashboard"></mat-datepicker-toggle>
                <mat-date-range-picker #fromToDateDashboard (closed)="processDateRangeOnlyForCustomRange('FirstGraph')"></mat-date-range-picker>
              </mat-form-field>

              <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style"  *ngIf="selectedOption === 'fiscal'">
                <mat-select placeholder="Select" [(ngModel)]="selectedYearForReimbursementGraph"
                  (selectionChange)="onChangeFiscalYear($event.value,'FirstGraph')">
                  <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                    {{sharedService.transformYearToFyFormat(item.year)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            <!-- </div> -->
          <!-- </ion-row> -->
        </div>


        <div *ngIf="isReimbursementGraphVisible">
          <div [ngClass]="{'dispNone' : !isReimbursementTypeTable}">
            <div class="dashboardGraphTable table-container">
              <table id="table-data">
                <thead>
                  <tr class="custom-size">
                    <th>Reimbursement Type </th>
                    <th>Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of reimbursementTypeTable">
                    
                    <td>{{data.reimbursementType}}</td>
                    <td>{{data.count}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          
          <div [ngClass]="{'dispNone' : isReimbursementTypeTable}" id="bar-line-chart" style="width: 100%; height: 400px;"></div>
        </div>
      </div>
    </ion-col>

    <ion-col size="12" size-md="6">
      <div class="graphs" >
        <ion-row class="justify-content-center">
          <ion-col size="12" size-md="7">
            <div class="fs-16 fs_14ForMobile font_bold">Total Expense Amount </div>
          </ion-col>
          <ion-col size="12" size-md="5">
            <div class="d-flex graph-icon">
              <span (click)="switchApprovedByFinanceGraph('bar')">
                <img *ngIf="isApprovedByFinanceIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
                <img *ngIf="isApprovedByFinanceIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
              </span>
              <span (click)="switchApprovedByFinanceTable()">
                <img *ngIf="!isApprovedByFinanceTable" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                <img *ngIf="isApprovedByFinanceTable" src="././assets/icon/TableIconActive.svg" alt="">
              </span>
              <span (click)="switchApprovedByFinanceGraph('line')">
                <img *ngIf="isApprovedByFinanceIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt=""
                  class="cp">
                <img *ngIf="isApprovedByFinanceIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
              </span>
              <span>
                <img (click)="downloadChartAsPDF('Total Expense Amount','secondGraph')" src="././assets/icon/downloadIcon.svg" alt=""
                  class="cp">
              </span>
            </div>
          </ion-col>
        </ion-row>

        <ion-col size="12">
          <div [ngClass]="{'dispNone' : !isApprovedByFinanceTable}">
            <div class="dashboardGraphTable table-container">
              <table id="table-approvedByFinance-data">
                <thead>
                  <tr class="custom-size">
                    <th>year</th>
                    <th>Total amount paid in reimbursements</th>
                    <th>No. of employees</th>
                  </tr>
                </thead>
                <tbody>
                  
                  <tr *ngFor="let data of arrApprovedByFinanceTable">
                    <td>{{data.year}}</td>
                    <td>{{data.totalAmount}}</td>
                    <td>{{data.employeeCount}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div [ngClass]="{'dispNone' : isApprovedByFinanceTable}" id="bar-line-approvedByFinance-chart" *ngIf="isFinanceAmountPaidGraphVisible" style="width: 100%; height: 400px;">
          </div>
        </ion-col>


      </div>
    </ion-col>
  </ion-row>

  <!-- second row for graph -->
  <ion-row class="pt-10">
    <ion-col size="12" size-md="6">
      <div class="graphs">
        <ion-row class="justify-content-center">
          <ion-col size="12" size-md="7">
            <div class="fs-16 fs_14ForMobile font_bold">Expense Approved Vs Applied</div>
          </ion-col>
          
          <ion-col size="12" size-md="5">
            <div class="d-flex graph-icon">
              <span (click)="switchFinanceAmountPaidGraph('bar')">
                <img *ngIf="isFinanceAmountPaidIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
                <img *ngIf="isFinanceAmountPaidIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
              </span>
              <span (click)="switchFinanceAmountPaidTable()">
                <img [ngClass]="{'dispNone' : isFinanceAmountPaidTable}" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                <img *ngIf="isFinanceAmountPaidTable" src="././assets/icon/TableIconActive.svg" alt="">
              </span>
              <span (click)="switchFinanceAmountPaidGraph('line')">

                <img *ngIf="isFinanceAmountPaidIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt=""
                  class="cp">
                <img *ngIf="isFinanceAmountPaidIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
              </span>
              <span>
                <img (click)="downloadChartAsPDF('Expense Paid VS Applied',selectedOptionThird)" src="././assets/icon/downloadIcon.svg" alt=""
                  class="cp">
              </span>
            </div>
          </ion-col>
        </ion-row>
        <div class="phi-flex-wrap-center phi-gap-12 mt-10 mb-10">
          <!-- <ion-row> -->
            <!-- <div class="d-flex "> -->

              <mat-form-field class="w-100 mw-sm-250 mat mat-height40 mat-input-style" >
                <mat-select [(value)]="selectedOptionThird" (selectionChange)="onChangeExpenseDate($event.value,'thirdGraph')">
                  <mat-option *ngFor="let option of dateRangeOptions" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
               
              <mat-form-field class="w-100 mw-sm-250 mat mat-height40 mat-input-style" *ngIf="selectedOptionThird === 'custom'">
                <mat-date-range-input [rangePicker]="fromToDateDashboard">
                  <input matStartDate placeholder="Start date" [(ngModel)]="taskDateRangethirdGraph.start" name="startDate" readonly>
                  <input matEndDate placeholder="End date" [(ngModel)]="taskDateRangethirdGraph.end" name="endDate" readonly>
                </mat-date-range-input>
              
                <mat-datepicker-toggle matIconSuffix [for]="fromToDateDashboard"></mat-datepicker-toggle>
                <mat-date-range-picker #fromToDateDashboard (closed)="processDateRangeOnlyForCustomRange('thirdGraph')"></mat-date-range-picker>
              </mat-form-field>

              <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style"  *ngIf="selectedOptionThird === 'fiscal'">
                <mat-select placeholder="Select" [(ngModel)]="selectedYearForReimbursement"
                  (selectionChange)="onChangeFiscalYearForThirdGraph($event.value,'thirdGraph')">
                  <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                    {{sharedService.transformYearToFyFormat(item.year)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

            <!-- </div> -->
          <!-- </ion-row> -->
        </div>

 
        <ion-col size="12">
          <div [ngClass]="{'dispNone' : !isFinanceAmountPaidTable}">
            <div class="dashboardGraphTable table-container">
              <table id="table-data-Finance-Employee">
                <thead>
                  <tr class="custom-size">
                    <th>Expense Type </th>
                    <th>Amout paid by finance</th>
                    <th >Amount by employees</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of arrApprovedPaidAmountTable">
                    <td>{{data.reimbursementType}}</td>
                    <td>{{data.totalActualAmount}}</td>
                    <td>{{data.totalAssignedAmount}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div [ngClass]="{'dispNone' : isFinanceAmountPaidTable}" *ngIf="isApprovedByFinanceGraphVisible" id="bar-line-amount-chart" style="width: 100%; height: 400px;"></div>
        </ion-col>
      </div>
    </ion-col>

  </ion-row>

</div>

